<template>
    <div class="avail_content">
      <div class="avail_search">
         <pro-search 
      :fileds="AdventSearchFiled"
      :form="queryForm"
      @search="handleSearch"
      @reset="handleReset"
      >
        <template slot="warehouseCode">
          <!-- <cascaderSelect v-if="isEnterprise" ref="cascaderSelect" :is-default-select="false" @change="handleWhChange"></cascaderSelect> -->
          <select-dom  ref="selectDom" v-model="queryForm.shipperId" :is-every-request="false" :list="ProjectList" @onSearch="onSearchProject" @checkedList="checkedList" />
        </template>
      </pro-search>
      </div>
      <div class="avail_table">
        <a-table
        :columns="AdventTableColumns"
        :data-source="goodsData"
        class="table-sigle"
        :loading="loading"
        row-key="goodsCode"
        :scroll="{ x: 'calc(700px + 50%)'}"
        :pagination="pagination"
        @change="handleTableChange"
        >
          <template slot="goodsName" slot-scope="text">
          <a-tooltip>
            <template slot="title">{{text}}</template>
             <p class="overlength"> {{text}}</p>
            </a-tooltip>
          </template>
        </a-table>
      </div>
    </div>
</template>

<script>
import SelectDom from '@/components/select/SelectDom'
// import cascaderSelect from '@/components/cascaderSelect/index.vue'
import ProSearch from '@/components/TableSearch/index.vue'
import currency from 'currency.js'
import { getWareHouse } from '../../../../warehouseOrder/api'
import {AdventTableColumns,AdventSearchFiled} from '../constant'
import { willOverdueStock} from '../../api'

  export default {
    name:'Advent',
    components:{
      SelectDom,
      // cascaderSelect,
      ProSearch
    },
    props:{
      checkTab:{
        type:String,
        default:'advent'
      }
    },
    data(){
      return {
        queryForm:{},
        ProjectList: [],
        AdventTableColumns,
        AdventSearchFiled,
        goodsData: [],
        isEnterprise:false,
        loading:false,
        pagination: {
          current: 1,
          total: 0,
          pageSize:10,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          onShowSizeChange: (current, pageSize) => {
            this.pagination.pageSize = pageSize
          },
          showQuickJumper: true,
          showTotal: total => `共 ${total} 条`
      },
      }
    },
    watch:{
      checkTab(){
         if(this.checkTab==='advent'){
         this.getData();
        }
      }
    },
    created() {
      //  const {creditCode}=this.$store.state.user
      // if(!creditCode){
      //   this.getWareHouse()
      // }else{
      //   this.getData();
      // }
      // this.isEnterprise=!!creditCode
    },
    methods:{
      init(){
        this.getWareHouse()
      },
       handleSearch(form){
      this.pagination.current=1
      this.queryForm={
        ...form,
      }
      this.getData();
    },
      handleWhChange(data){
        this.queryForm.warehouse_name = data.label
        this.ProjectList=[data]
        this.getData(true)
      },
    //  async handleExport(){
    //    await shipperGoodsStockExport(this.queryForm)
    //    EventBus.$emit('taskPopover')
    //   },
      checkedList(data){
        this.queryForm.warehouse_name = data.label;
        this.queryForm.warehouseCode = data.tenantId
        this.getData(true)
      },
      handleReset(){
        this.pagination.current=1
        this.queryForm={}
        this.$refs.selectDom.removeData()
        // if(!this.isEnterprise){
        //   this.$refs.selectDom.removeData()
        // }else{
        //   this.$refs.cascaderSelect.handleClear()
        // }
        this.getData();
      },
    onSearchProject(tenantName){
      this.getWareHouse(tenantName)
    },
   async getData(current = null){
      this.loading=true;
      if(current){
        this.pagination.current = 1
      }
      const params = {
        size: this.pagination.pageSize,
        page: this.pagination.current,
        sort: [
        {
            "near_odue_amount_total": {
                "order": "desc"
            }
        }
    ],
      }
      const {warehouseCode,shipperId,...restParasm} =this.queryForm;
      if(!shipperId){
        this.$message.warning('未选择仓库,无法查询数据')
        this.loading=false;
        return
      }
      const {creditCode,customers,customerId}=this.$store.state.user;
      let customerIds=[];
      if(creditCode){
        customerIds=customers.map(item=>item.customerId)
      }else{
        customerIds=[customerId]
      }
      try {
        const res= await willOverdueStock({...params,filter:{...restParasm,shipperId,shipper_id:customerIds}})
        this.goodsData = res.records
        this.pagination.total = res.total
        this.countTotal(this.goodsData,res.total)
        this.loading=false;
      } catch (error) {
        this.loading=false;
        this.countTotal([],0)
      }
    },
    countTotal(data,total){
      const messageData ={
        total,
        defaultTotal:0,
        bigTotal:0,
      }
      data.forEach(item=>{
        messageData.defaultTotal= currency( messageData.defaultTotal).add(item.near_odue_amount_total||0)
        messageData.bigTotal= currency( messageData.bigTotal).add(item.near_big_odue_amount_total||0)
      })
      this.$emit('total',messageData)
    },
     handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current
      }
      this.getData();
    },
    getWareHouse(tenantName=null){
      const data = {
          customerCodes: [this.$store.state.user.customerCode],
          needExcludeDefaultTenant: true,
          tenantName,
          isReadConfig:true
      }
      getWareHouse(data,{size:500}).then((res) => {
        if(res.records.length <= 0){
          this.ProjectList = []
          this.$message.warning('未选择仓库,无法查询数据')
          return
        }
        const arr = res.records.map((e) => {
            return {
                ...e,
                label: e.tenantName,
                formatLabel: `${e.tenantName} (${e.shipperName})`,
                value: e.customerId
            }
        })
        this.ProjectList = arr
        if(this.goodsData.length <= 0){
          if(arr.length > 0  && !this.queryForm.shipperId ){
            this.queryForm.warehouseCode = arr[0].tenantId
            this.queryForm.shipperId = arr[0].customerId
          }
          this.getData()
        }
      })
    },
    }
  }
</script>

<style lang="less" scoped>
.avail_content {
    background-color: #fff;
    border-radius: 6px;
    padding: 24px;
}
  .avail_search {
    margin-bottom: 12px;
  }
  .avail_table {
    // background-color: #fff;
    // border-radius: 6px;
    border-top: 1px solid #E7E9EC;
    padding-top: 24px;
  }
  .avail_form {
    /deep/.ant-form-item {
      width: 100%;
      .ant-form-item-label {
        width: 80px;
      }
      .ant-form-item-control-wrapper {
        width: calc(100% - 80px);
      }
    }
    .ant-col-6 {
      padding-right: 20px;
    }
    .form-btns {
      text-align: center;
      .form-btn {
        margin-left: 20px;
      }
    }
  }
  .operate_bar {
    margin-bottom: 24px;
    .btn_export {
      border: 1px solid #06B880;
      color: #06B880;
    }
  }
   .avail_form {
    /deep/.ant-form-item-label label {
      color: #606266;
    }
    /deep/ .ant-form-item-control-wrapper input {
      color: #171717 !important;
    }

  }
  .search_btn {
    color: #06B880;
    border-color: #06B880;
  }
  .overlength {
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
</style>